require("!!/app/node_modules/script-loader/addScript.js")(require("!!/app/node_modules/raw-loader/index.js!/app/node_modules/chart.js/dist/Chart.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chart.js/dist/Chart.min.js
// module id = ./node_modules/script-loader/index.js!./node_modules/chart.js/dist/Chart.min.js
// module chunks = 3